import { FC } from "react";
import { copy } from "shared/assets";
import { Cookie } from "shared/assets/icons";

import { Modal, List, Title, Button, ButtonContainer } from "shared/components";
import { Spacer } from "shared/layout";
import { ITheme } from "shared/types";

interface CookieNoticeProps {
  handleAcceptAll: () => void;
  handleDenyAnalytical: () => void;
}

export const CookieNotice: FC<CookieNoticeProps> = ({
  handleAcceptAll,
  handleDenyAnalytical,
}) => {
  return (
    <Modal
      icon={Cookie}
      title={copy.cookieNotice.title}
      dataTestId="cookie_notice"
      showCloseButton={false}
    >
      <Spacer size="l">
        <Spacer size="s">
          <Title
            title={copy.cookieNotice.body.title}
            size="s"
            asComponent="p"
          />
          <p>{copy.cookieNotice.body.message}</p>
          <List>
            {copy.cookieNotice.body.list.map((text: string, index: number) => (
              <li key={index}>{text}</li>
            ))}
          </List>
        </Spacer>
        <ButtonContainer>
          <Button
            theme={ITheme.primary}
            onClick={handleAcceptAll}
            data-testid="accept_all"
          >
            {copy.cookieNotice.acceptAll}
          </Button>
          <Button
            theme={ITheme.secondary}
            onClick={handleDenyAnalytical}
            data-testid="deny_analytical"
          >
            {copy.cookieNotice.denyAnalytical}
          </Button>
        </ButtonContainer>
      </Spacer>
    </Modal>
  );
};
